/* import __COLOCATED_TEMPLATE__ from './teammate-attribute-cell.hbs'; */
/* RESPONSIBLE TEAM: team-ml */
import Component from '@glimmer/component';

interface Row {
  teammate?: { id: string | number };
  teammateAssignments?: Record<string, string[]>;
}

interface Column {
  teammateAttributeId?: string;
  widthStyle?: string;
}

interface Signature {
  Args: {
    row: Row;
    column: Column;
  };
}

export default class TeammateAttributeCell extends Component<Signature> {
  get displayValue(): string {
    let { row, column } = this.args;
    if (!row.teammate || !column.teammateAttributeId) {
      return '';
    }
    let assignments = row.teammateAssignments || {};
    let values = assignments[column.teammateAttributeId];
    if (values && values.length > 0) {
      return values.join(', ');
    }
    return '—';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'TableCells::TeammateList::TeammateAttributeCell': typeof TeammateAttributeCell;
    'table-cells/teammate-list/teammate-attribute-cell': typeof TeammateAttributeCell;
  }
}
